<template>
    <div class="a" style="display: none;" :style="{ display: 'block' }">
        <top></top>
        <navs></navs>
        <div class="content">
            <div class="b">
                <div class="left">
                    <div class="cont">
                        <div class="cont_a">
                            <div class="cont_left">
                                <div class="bule"></div>
                                <h2 @click="sgjj">生命见证</h2>
                            </div>
                            <!-- <div class="cont_right">
                                更多&nbsp;>>
                            </div> -->
                        </div>
                        <div style="display: flex;overflow: hidden;flex-wrap: wrap;height: 190px;">
                            <div class="cont_title" v-for="(item, index) in mlist" :key="index" @click="sgjjs(item.id)">
                                <div class="image">
                                    <img :src="item.placard" alt="" width="158px" height="158px">
                                </div>
                                <div class="sg">
                                    <div class="sgjj">
                                        <span style="font-size: 16px;">生命见证：</span><span style="font-size: 11px;">{{
        item.abstract }}</span>
                                    </div>
                                    <div class="sg_cont">
                                        <span>{{ item.briefInfo }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="cont">
                        <div class="cont_a">
                            <div class="cont_left">
                                <div class="bule"></div>
                                <h2 @click="tqjj">事工团契</h2>
                            </div>
                            <!-- <div class="cont_right">
                                更多&nbsp;>>
                            </div> -->
                        </div>
                        <div style="display: flex;overflow: hidden;flex-wrap: wrap;height: 190px;">
                            <div class="cont_title" v-for="(item, index) in flist" :key="index" @click="tqjjs(item.id)">
                                <div class="image">
                                    <img :src="item.placard" alt="" width="158px" height="158px">
                                </div>
                                <div class="sg">
                                    <div class="sgjj">
                                        <span style="font-size: 16px;">事工团契：</span><span style="font-size: 11px;">{{
        item.abstract }}</span>
                                    </div>
                                    <div class="sg_cont">
                                        <span>{{ item.briefInfo }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="right">
                    <div class="conts">
                        <div class="cont_a">
                            <div class="cont_left">
                                <div class="bule"></div>
                                <h2 @click="sgjj">生命见证（事工新闻）</h2>
                            </div>
                            <div class="cont_right" @click="sgjj">
                                更多&nbsp;>>
                            </div>
                        </div>
                        <div class="cont_c" style="display: flex;overflow: hidden;flex-wrap: wrap;height: 435px;">
                            <div class="jj" v-for="(item, index) in mlist" :key="index" @click="sgjjs(item.id)">
                                <img :src="item.placard" alt="" width="79px" height="79px">
                                <div class="cont_jj">
                                    <h3>{{ item.name }}</h3>
                                    <div class="jj_text">
                                        描述：{{ item.briefInfo }}
                                    </div>
                                    <div class="jj_text">
                                        <span>作者：{{ item.speaker }}</span>&nbsp;&nbsp;&nbsp;<span>发布时间：{{ item.createTime }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import { ministries, fellowships } from "../api/index"
export default {
    components: {
        top,
        bottom,
        navs
    },
    data() {
        return {
            mlist: [],
            flist: []
        }
    },
    created() {
        ministries().then(res => {
            console.log(res)
            this.mlist = res.data.data.records
        })
        fellowships().then(res => {
            console.log(res)
            this.flist = res.data.data.records
        })
    },
    methods: {
        sgjjs(item) {
            console.log(item)
            this.$router.push({ path: "/sgcont", query: { id: item } })
        },
        sgjj() {
            this.$router.push({ path: "/sgjj"})
        },
        tqjjs(item) {
            this.$router.push({ path: "/tqcont", query: { id: item } })
        },
        tqjj() {
            this.$router.push({ path: "/tqjj"})
        }
    }
}
</script>
<style scoped>
.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
}

.content {
    width: 100%;
    height: 480px;
    background-image: url(../image/back1.png);
    padding-top: 40px;
    padding-bottom: 40px;
}

.b {
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}

.left {
    width: 45%;
    height: 480px;
    display: flex;
    flex-direction: column;
}

.cont {
    width: 100%;
    height: 240px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.conts {
    width: 100%;
    height: 240px;
    /* display: flex; */
    flex-direction: column;
    justify-content: center;
}

.cont_a {
    width: 100%;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.cont_left {
    /* width: 2.5rem; */
    display: flex;
    align-items: center;
}

.bule {
    width: 5px;
    height: 16px;
    background: #1463FF;
    margin-right: 5px;
}

.cont_right {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #666666;
    line-height: 11px;
    font-style: normal;
}

.cont_b {
    width: 31%;
    height: 163px;
    background: #FFFFFF;
    box-shadow: 4px 4 6px 0px rgba(75, 98, 168, 0.3);
}

.cont_top {
    width: 100%;
    height: 127px;
}

.cont_bottom {
    height: 36px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.center {
    width: 1.2625rem;
    height: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: .1375rem;
    font-style: normal;
    display: flex;
    align-items: center;
    justify-content: center;
}

.right {
    width: 40%;
    /* height: 480px; */
    display: flex;
    padding-top: 10px;
    flex-direction: column;
}

.information {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
}

.infor {
    width: 45%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}

.cont_text {
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
}

.hidden {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 400;
    font-size: 11px;
    color: #666666;
}

.book {
    width: 100%;
    height: 180px;
    background-color: #FFFFFF;
}

.download {
    width: 80%;
    margin: 0 auto;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 11px;
    color: #333333;
}

.image {
    width: 45%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cont_title {
    width: 100%;
    height: 190px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
}

.sg {
    width: 55%;
    height: 158px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.sgjj {
    font-weight: 900;
    color: #333333;
}

.sg_cont {
    font-weight: 400;
    color: #333333;
}

.jj {
    /* width: 45%; */
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.jj:hover {
    /* width: 45%; */
    color: #1463FF;
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.cont_jj {
    width: 75%;
    height: 60px;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
}

.jj_text {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: .1375rem;
    color: #666666;
}

.cont_c {
    width: 100%;
    display: flex;
    flex-direction: column;
}
.cont_left:hover{
    color: #1463FF;
}
.cont_right:hover{
    color: #1463FF;
}
</style>



// WEBPACK FOOTER //
// src/views/tq.vue